// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../../../common/util.bs.js";
import * as BsCss from "../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Fresnel from "../../../bindings/Fresnel.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as StaticImage from "../../StaticImage.bs.js";
import * as Localization from "../../../config/Localization.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.backgroundImage({
            NAME: "url",
            VAL: "/images/about/about_header_new.png"
          }),
      tl: {
        hd: BsCss.backgroundRepeat("noRepeat"),
        tl: {
          hd: BsCss.backgroundPosition("center"),
          tl: {
            hd: BsCss.backgroundSize("cover"),
            tl: {
              hd: BsCss.position("relative"),
              tl: {
                hd: BsCss.height(BsCss.px(700)),
                tl: {
                  hd: BsCss.media("(max-width: 767px)", {
                        hd: BsCss.height(BsCss.px(570)),
                        tl: {
                          hd: BsCss.overflow("hidden"),
                          tl: /* [] */0
                        }
                      }),
                  tl: {
                    hd: BsCss.media("(min-width: 768px) and (max-width: 1023px)", {
                          hd: BsCss.height(BsCss.px(750)),
                          tl: /* [] */0
                        }),
                    tl: {
                      hd: BsCss.media("(min-width: 1024px) and (max-width: 1280px)", {
                            hd: BsCss.height(BsCss.px(563)),
                            tl: /* [] */0
                          }),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var waveImage = Curry._1(BsCss.style, {
      hd: BsCss.position("absolute"),
      tl: {
        hd: BsCss.height(BsCss.pct(100.0)),
        tl: {
          hd: BsCss.important(BsCss.width(BsCss.pct(100.0))),
          tl: {
            hd: BsCss.media("(max-width: 500px)", {
                  hd: BsCss.important(BsCss.width(BsCss.pct(130.0))),
                  tl: {
                    hd: BsCss.marginLeft(BsCss.px(-60)),
                    tl: /* [] */0
                  }
                }),
            tl: {
              hd: BsCss.media("(min-width: 501px) and (max-width: 600px)", {
                    hd: BsCss.important(BsCss.width(BsCss.pct(130.0))),
                    tl: {
                      hd: BsCss.marginLeft(BsCss.px(-70)),
                      tl: /* [] */0
                    }
                  }),
              tl: {
                hd: BsCss.media("(min-width: 600px) and (max-width: 767px)", {
                      hd: BsCss.important(BsCss.width(BsCss.pct(125.0))),
                      tl: {
                        hd: BsCss.marginLeft(BsCss.px(-90)),
                        tl: /* [] */0
                      }
                    }),
                tl: {
                  hd: BsCss.selector("span > img", {
                        hd: BsCss.important(BsCss.height("inherit_")),
                        tl: /* [] */0
                      }),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var innerContent = Curry._1(BsCss.style, {
      hd: BsCss.media("(max-width: 768px)", {
            hd: BsCss.marginLeft(BsCss.px(20)),
            tl: {
              hd: BsCss.marginRight(BsCss.px(20)),
              tl: /* [] */0
            }
          }),
      tl: {
        hd: BsCss.media("(min-width: 1024px)", {
              hd: BsCss.marginLeft(BsCss.px(30)),
              tl: {
                hd: BsCss.marginRight(BsCss.px(30)),
                tl: {
                  hd: BsCss.display("flex"),
                  tl: {
                    hd: BsCss.alignItems("center"),
                    tl: {
                      hd: BsCss.height(BsCss.pct(100.0)),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }),
        tl: {
          hd: BsCss.media("(min-width: 1280px)", {
                hd: BsCss.marginLeft("auto"),
                tl: {
                  hd: BsCss.marginRight("auto"),
                  tl: {
                    hd: BsCss.maxWidth(BsCss.px(1200)),
                    tl: /* [] */0
                  }
                }
              }),
          tl: /* [] */0
        }
      }
    });

var leftContainer = Curry._1(BsCss.style, {
      hd: BsCss.media("(min-width: 1200px)", {
            hd: BsCss.width(BsCss.pct(50.0)),
            tl: /* [] */0
          }),
      tl: {
        hd: BsCss.media("(min-width: 1024px) and (max-width: 1439px)", {
              hd: BsCss.width(BsCss.pct(50.0)),
              tl: /* [] */0
            }),
        tl: {
          hd: BsCss.media("(min-width: 1440px)", {
                hd: BsCss.width(BsCss.pct(60.0)),
                tl: /* [] */0
              }),
          tl: /* [] */0
        }
      }
    });

var rightContainer = Curry._1(BsCss.style, {
      hd: BsCss.media("(max-width: 767px)", {
            hd: BsCss.width(BsCss.pct(90.0)),
            tl: {
              hd: BsCss.marginTop(BsCss.px(-21)),
              tl: /* [] */0
            }
          }),
      tl: {
        hd: BsCss.media("(min-width: 768px) and (max-width: 1023px)", {
              hd: BsCss.width(BsCss.pct(90.0)),
              tl: {
                hd: BsCss.marginLeft("auto"),
                tl: {
                  hd: BsCss.marginRight("auto"),
                  tl: /* [] */0
                }
              }
            }),
        tl: {
          hd: BsCss.media("(min-width: 1024px) and (max-width: 1439px)", {
                hd: BsCss.width(BsCss.pct(50.0)),
                tl: {
                  hd: BsCss.height(BsCss.pct(100.0)),
                  tl: /* [] */0
                }
              }),
          tl: {
            hd: BsCss.media("(min-width: 1440px)", {
                  hd: BsCss.width(BsCss.pct(40.0)),
                  tl: /* [] */0
                }),
            tl: /* [] */0
          }
        }
      }
    });

var aboutText = Curry._1(BsCss.style, {
      hd: BsCss.position("relative"),
      tl: {
        hd: BsCss.color(BsCss.hex("FFFFFF")),
        tl: {
          hd: BsCss.fontSize(BsCss.px(52)),
          tl: {
            hd: BsCss.fontWeight({
                  NAME: "num",
                  VAL: 500
                }),
            tl: {
              hd: BsCss.lineHeight(BsCss.px(64)),
              tl: {
                hd: BsCss.maxWidth(BsCss.px(1000)),
                tl: {
                  hd: BsCss.marginTop("auto"),
                  tl: {
                    hd: BsCss.marginBottom("auto"),
                    tl: {
                      hd: BsCss.media("(max-width: 767px)", {
                            hd: BsCss.fontSize(BsCss.px(32)),
                            tl: {
                              hd: BsCss.fontWeight({
                                    NAME: "num",
                                    VAL: 400
                                  }),
                              tl: {
                                hd: BsCss.lineHeight(BsCss.px(40)),
                                tl: {
                                  hd: BsCss.paddingTop(BsCss.px(54)),
                                  tl: {
                                    hd: BsCss.textAlign("center"),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }),
                      tl: {
                        hd: BsCss.media("(min-width: 768px) and (max-width: 1023px)", {
                              hd: BsCss.marginLeft(BsCss.px(30)),
                              tl: {
                                hd: BsCss.marginRight(BsCss.px(30)),
                                tl: {
                                  hd: BsCss.paddingTop(BsCss.px(70)),
                                  tl: /* [] */0
                                }
                              }
                            }),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var underlineText = Curry._1(BsCss.style, {
      hd: BsCss.fontWeight("bold"),
      tl: {
        hd: BsCss.textDecoration("underline"),
        tl: /* [] */0
      }
    });

var phoneImage = Curry._1(BsCss.style, {
      hd: BsCss.position("absolute"),
      tl: {
        hd: BsCss.bottom("zero"),
        tl: {
          hd: BsCss.important(BsCss.width(BsCss.pct(28.0))),
          tl: {
            hd: BsCss.media("(max-width: 500px)", {
                  hd: BsCss.important(BsCss.width(BsCss.pct(70.0))),
                  tl: {
                    hd: BsCss.position("absolute"),
                    tl: {
                      hd: BsCss.left("zero"),
                      tl: /* [] */0
                    }
                  }
                }),
            tl: {
              hd: BsCss.media("(min-width: 501px) and (max-width: 767px)", {
                    hd: BsCss.important(BsCss.width(BsCss.pct(60.0))),
                    tl: {
                      hd: BsCss.position("absolute"),
                      tl: {
                        hd: BsCss.left("zero"),
                        tl: /* [] */0
                      }
                    }
                  }),
              tl: {
                hd: BsCss.media("(min-width: 768px) and (max-width: 1023px)", {
                      hd: BsCss.important(BsCss.width(BsCss.pct(50.0))),
                      tl: /* [] */0
                    }),
                tl: {
                  hd: BsCss.media("(min-width: 1024px) and (max-width: 1279px)", {
                        hd: BsCss.important(BsCss.width(BsCss.pct(40.0))),
                        tl: /* [] */0
                      }),
                  tl: {
                    hd: BsCss.media("(min-width: 1280px) and (max-width: 1440px)", {
                          hd: BsCss.important(BsCss.width(BsCss.pct(40.0))),
                          tl: /* [] */0
                        }),
                    tl: {
                      hd: BsCss.media("(min-width: 2000px)", {
                            hd: BsCss.important(BsCss.width(BsCss.pct(22.0))),
                            tl: /* [] */0
                          }),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var Styles = {
  container: container,
  waveImage: waveImage,
  innerContent: innerContent,
  leftContainer: leftContainer,
  rightContainer: rightContainer,
  aboutText: aboutText,
  underlineText: underlineText,
  phoneImage: phoneImage
};

function AboutHeader(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        JsxRuntime.jsx(Fresnel.Media.make, {
                              lessThan: "md",
                              children: JsxRuntime.jsx(StaticImage.make, {
                                    src: "/images/about/mobile_redline.png",
                                    alt: "Prezzee Red Line",
                                    width: 797,
                                    height: 546,
                                    className: waveImage,
                                    loading: "eager"
                                  })
                            }),
                        JsxRuntime.jsx(Fresnel.Media.make, {
                              greaterThanOrEqual: "md",
                              children: JsxRuntime.jsx(StaticImage.make, {
                                    src: "/images/about/about_background_line.png",
                                    alt: "Prezzee Red Line",
                                    width: 2880,
                                    height: 1278,
                                    className: waveImage,
                                    loading: "eager"
                                  })
                            })
                      ]
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("h1", {
                                    children: [
                                      Util.ReactStuff.s("We're on a "),
                                      JsxRuntime.jsx("span", {
                                            children: Util.ReactStuff.s("mission"),
                                            className: underlineText
                                          }),
                                      Util.ReactStuff.s(" to make gift cards fun, "),
                                      Belt_Option.mapWithDefault(Localization.getLocalizedString("personalise"), null, Util.ReactStuff.s),
                                      Util.ReactStuff.s("d and easy to use!")
                                    ],
                                    className: aboutText
                                  }),
                              className: leftContainer
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(StaticImage.make, {
                                    src: "/images/about/about_phone.png",
                                    alt: "Prezzee About Us",
                                    width: 570,
                                    height: 590,
                                    className: phoneImage,
                                    loading: "eager"
                                  }),
                              className: rightContainer
                            })
                      ],
                      className: innerContent
                    })
              ],
              className: container
            });
}

var make = AboutHeader;

export {
  Styles ,
  make ,
}
/* container Not a pure module */
